import { ApplicationRef, enableProdMode, isDevMode } from '@angular/core';
import { bootstrapApplication, enableDebugTools } from '@angular/platform-browser';
import { AuthState } from '@trtl/portal/auth';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

environment.production && enableProdMode();

// LOCAL SANDBOX ONLY: migrate the exact legacy Admin bypass token to the current
// crafted dev token (embedding username=system). Runs after AuthState has loaded
// localStorage and before bootstrap, so the route guard sees the valid token.
// Gated by devAuthBypass (absent from staging/prod env files -> no-op there) and
// matches ONLY the exact legacy string -- no general malformed-token handling.
if (environment.devAuthBypass && AuthState.accessToken() === 'MOCK_TOKEN_ADMIN') {
  const b64url = (o: object) => btoa(JSON.stringify(o)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  AuthState.setTokens({
    accessToken: `MOCK_TOKEN_ADMIN.${b64url({ username: 'system' })}.local`,
    idToken: `dummy.${b64url({ 'custom:role': 'admin' })}.dummy`,
  } as never);
}

bootstrapApplication(AppComponent, appConfig)
  .then((m) => {
    if (isDevMode()) {
      const compRef = m.injector.get(ApplicationRef).components[0];
      enableDebugTools(compRef);
    }
  })
  .catch((err) => {
    // eslint-disable-next-line
    console.error(err);
  });
